export const ADD_SHOW_FAVOURITE = 'ADD_SHOW_FAVOURITE';
export const REMOVE_SHOW_FAVOURITE = 'REMOVE_SHOW_FAVOURITE';
export const ADD_EPISODE_FAVOURITE = 'ADD_EPISODE_FAVOURITE';
export const REMOVE_EPISODE_FAVOURITE = 'REMOVE_EPISODE_FAVOURITE';
export const CLEAR_FAVOURITES = 'CLEAR_FAVOURITES';

export const addShowFavourite = show => {
    return async dispatch => {
        dispatch({type: ADD_SHOW_FAVOURITE, payload: show});
    };
};

export const removeShowFavourite = show => {
    return async dispatch => {
        dispatch({type: REMOVE_SHOW_FAVOURITE, payload: show});
    };
};

export const addEpisodeFavourite = episode => {
    return async dispatch => {
        dispatch({type: ADD_EPISODE_FAVOURITE, payload: episode});
    };
};

export const removeEpisodeFavourite = episode => {
    return async dispatch => {
        dispatch({type: REMOVE_EPISODE_FAVOURITE, payload: episode});
    };
};

export const clearFavourites = () => {
    return async dispatch => {
        dispatch({type: CLEAR_FAVOURITES});
    };
};
